import { EMPTY_STRING } from '../../../../constants/common'
import { CURRENCY_SYMBOL_MAP } from '../../../../constants/currency'
import { formatNumberWithSeparators } from '../../../../utils/number'

export function getCurrencySymbol(currencyCode) {
  return currencyCode
    ? (CURRENCY_SYMBOL_MAP[currencyCode] ?? currencyCode)
    : EMPTY_STRING
}

export function formatBudgetPlanAmount(value, currencyCode) {
  const formattedAmount = formatNumberWithSeparators(value)

  if (formattedAmount) {
    const currencySymbol = getCurrencySymbol(currencyCode)

    return currencySymbol
      ? `${formattedAmount} ${currencySymbol}`
      : formattedAmount
  }

  return EMPTY_STRING
}
